/** Client-side mirror of `server/opportunity-handlers/visibility.ts` delete rules. */

const PRIVILEGED_DELETE_ROLES = [
  "admin",
  "owner",
  "org_admin",
  "org_owner",
  "dev",
  "platform_owner",
  "platform_admin",
  "platform_dev",
] as const;

export function userCanDeleteOpportunity(
  userId: string,
  hasRole: (...roles: string[]) => boolean,
  opportunity: { created_by_user_id: string | null },
): boolean {
  if (hasRole(...PRIVILEGED_DELETE_ROLES)) return true;
  return opportunity.created_by_user_id === userId;
}
